const CommonPostBody = () => {
  return (
    <div>
      <noscript
        dangerouslySetInnerHTML={{
          __html: `
<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-T3Q873H"
height="0" width="0" style="display:none;visibility:hidden"></iframe>
        `,
        }}
      ></noscript>
    </div>
  );
};

export default CommonPostBody;
